"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityReverseConnectForm = exports.EntityReverseConnectFormDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var utils_1 = require("@shapeable/utils");
var react_animate_height_1 = __importDefault(require("react-animate-height"));
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_entities_1 = require("../../hooks/use-entities");
var use_form_1 = require("../hooks/use-form");
var field_container_1 = require("../../components/elements/field-container");
var entity_reverse_field_form_name_1 = require("../utils/entity-reverse-field-form-name");
var lodash_1 = require("lodash");
var record_to_array_1 = require("../utils/record-to-array");
var entity_value_1 = require("../../components/entities/entity-value");
var client_1 = require("@apollo/client");
var icon_button_1 = require("../../components/elements/icon-button");
var use_lang_1 = require("../../hooks/use-lang");
var entity_update_mutation_field_name_1 = require("../../utils/entity-update-mutation-field-name");
var is_multi_field_1 = require("../utils/is-multi-field");
var loader_1 = require("../../components/elements/loader");
var entity_value_checkbox_1 = require("./entity-value-checkbox");
var sprintf_js_1 = require("sprintf-js");
var use_infinite_scroll_array_1 = require("../../hooks/use-infinite-scroll-array");
var toggle_1 = require("../../components/elements/toggle");
var entity_value_connections_1 = require("./entity-value-connections");
var info_tooltip_1 = require("../elements/info-tooltip");
var entity_reverse_connect_query_1 = require("../../utils/entity-reverse-connect-query");
var cls = (0, utils_1.classNames)('entity-reverse-field-form');
exports.EntityReverseConnectFormDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    font-size: ", ";\n  "], ["\n    width: 100%;\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(16))
});
var FormStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n    box-sizing: border-box;\n  "], ["\n    width: 100%;\n    box-sizing: border-box;\n  "])))
});
var ContextFieldsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", ";\n    padding-bottom: 0;\n    box-sizing: border-box;\n    width: 100%;\n    ", ";\n  "], ["\n    padding: ", ";\n    padding-bottom: 0;\n    box-sizing: border-box;\n    width: 100%;\n    ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.H_DOT_BG('line-subtle'))
});
var FieldContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var SelectStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding-right: ", ";\n  "], ["\n    padding-right: ", ";\n  "])), theme_1.theme.UNIT(6))
});
var DoneButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var LoaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme_1.theme.UNIT(8))
});
var ValueCheckboxStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    padding: ", " ", ";\n  "], ["\n    padding: ", " ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(6))
});
var ItemsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    max-height: calc(90vh - 150px);\n    overflow-y: auto;\n  "], ["\n    max-height: calc(90vh - 150px);\n    overflow-y: auto;\n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var HeadStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    background: ", ";\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: ", " ", ";\n    justify-content: space-between;\n    gap: ", ";\n    border-bottom: 1px solid ", ";\n  "], ["\n    background: ", ";\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: ", " ", ";\n    justify-content: space-between;\n    gap: ", ";\n    border-bottom: 1px solid ", ";\n  "])), theme_1.theme.COLOR('app-chrome'), theme_1.theme.UNIT(4), theme_1.theme.UNIT(5), theme_1.theme.UNIT(4), theme_1.theme.COLOR('line-subtle'))
});
var IntroStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    color: ", ";\n    font-weight: 400;\n    font-size: 1em;\n    padding-top: ", ";\n    height: 32px;\n    align-items: center;\n    flex-direction: row;\n    margin: 0;\n    display: none;\n  "], ["\n    color: ", ";\n    font-weight: 400;\n    font-size: 1em;\n    padding-top: ", ";\n    height: 32px;\n    align-items: center;\n    flex-direction: row;\n    margin: 0;\n    display: none;\n  "])), theme_1.theme.COLOR('text'), theme_1.theme.UNIT(4)),
  tablet: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    ", ";\n    padding-top: 0;\n    padding-left: ", ";\n    display: flex;\n  "], ["\n    ", ";\n    padding-top: 0;\n    padding-left: ", ";\n    display: flex;\n  "])), theme_1.theme.V_DOT_BG('line-subtle'), theme_1.theme.UNIT(6))
});
var IntroTextStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ValueAndIntroStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    \n  "], ["\n    display: flex;\n    align-items: center;\n    \n  "])))
});
var ToggleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    border-top: 1px solid ", ";\n\n    &:first-child {\n      border-top: none;\n    }\n  "], ["\n    border-top: 1px solid ", ";\n\n    &:first-child {\n      border-top: none;\n    }\n  "])), theme_1.theme.COLOR('line-subtle'))
});
var AssignmentsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(6)),
  tablet: (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    margin-top: 0;\n    margin-left: ", ";\n  "], ["\n    margin-top: 0;\n    margin-left: ", ";\n  "])), theme_1.theme.UNIT(6))
});
var InfoTooltipStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  InfoTooltip: (0, styled_components_1.default)(info_tooltip_1.InfoTooltip)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), InfoTooltipStyles),
  Head: styled_components_1.default.div(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), HeadStyles),
  ValueAndIntro: styled_components_1.default.div(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), ValueAndIntroStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  Intro: styled_components_1.default.h2(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), IntroStyles),
  IntroText: styled_components_1.default.span(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), IntroTextStyles),
  Toggle: (0, styled_components_1.default)(toggle_1.Toggle)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), ToggleStyles),
  Body: styled_components_1.default.div(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Form: styled_components_1.default.form(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), FormStyles),
  DoneButton: (0, styled_components_1.default)(icon_button_1.SubmitIconButton)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), DoneButtonStyles),
  Loader: (0, styled_components_1.default)(loader_1.Loader)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles),
  Items: styled_components_1.default.div(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Item: styled_components_1.default.div(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  Assignments: (0, styled_components_1.default)(entity_value_connections_1.EntityValueAssignments)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), AssignmentsStyles),
  ContextFields: styled_components_1.default.div(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), ContextFieldsStyles),
  FieldContainer: (0, styled_components_1.default)(field_container_1.FieldContainer)(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), FieldContainerStyles),
  ValueCheckbox: (0, styled_components_1.default)(entity_value_checkbox_1.EntityValueCheckbox)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), ValueCheckboxStyles)
};
var EntityReverseConnectForm = function (props) {
  var _a, _b;
  var className = props.className,
    children = props.children,
    entity = props.entity,
    fieldName = props.fieldName;
  var entities = (0, use_entities_1.useEntities)();
  var defn = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var _c = __read((0, react_1.useState)({
      orderBy: {
        fieldName: 'name'
      }
    }), 2),
    filterState = _c[0],
    setFilterState = _c[1];
  var _d = __read((0, react_1.useState)(false), 2),
    unassigned = _d[0],
    setUnassigned = _d[1];
  var formName = (0, entity_reverse_field_form_name_1.entityReverseFieldFormName)(defn, fieldName);
  var form = (0, use_form_1.useForm)(formName);
  var t = (0, use_lang_1.useLang)();
  var _e = __read(react_1.default.useState({}), 2),
    valueState = _e[0],
    setValueState = _e[1];
  // --- START MEMO -->
  var _f = react_1.default.useMemo(function () {
      var _a;
      var reverseFieldDefn = (_a = defn === null || defn === void 0 ? void 0 : defn.form) === null || _a === void 0 ? void 0 : _a.reverseFields[fieldName];
      // source entity type definition - this is the direct reverse field from the entity being linked to (the other side of the relationship)
      var sourceDefn = entities[reverseFieldDefn === null || reverseFieldDefn === void 0 ? void 0 : reverseFieldDefn.entityTypeName];
      // fields are easier to process as an array, with the key as a name property
      var sourceFields = sourceDefn ? (0, record_to_array_1.recordToArrayWithName)(sourceDefn.form.fields) : [];
      // find the source field in the source entity
      var sourceField = sourceFields.find(function (field) {
        return field.name === reverseFieldDefn.source;
      });
      // the source field must be set to the current entity value being viewed
      var sourceFieldValue = (0, is_multi_field_1.isMultiField)(sourceField) ? [entity.id] : entity.id;
      return {
        reverseFieldDefn: reverseFieldDefn,
        sourceDefn: sourceDefn,
        sourceField: sourceField,
        sourceFieldValue: sourceFieldValue
      };
    }, [entity, fieldName]),
    reverseFieldDefn = _f.reverseFieldDefn,
    sourceDefn = _f.sourceDefn,
    sourceField = _f.sourceField,
    sourceFieldValue = _f.sourceFieldValue;
  // -- END MEMO -->
  if (!defn) {
    console.error("EntityReverseConnectForm: entity definition not found", entity);
    return null;
  }
  if (!reverseFieldDefn) {
    console.error("EntityReverseConnectForm: reverse field definition not found", entity, fieldName);
    return null;
  }
  if (!sourceField) {
    console.error("EntityReverseConnectForm: source field definition not found", entity, fieldName, reverseFieldDefn);
    return null;
  }
  // initialize the form
  react_1.default.useEffect(function () {
    form.patch({
      canSubmit: function () {
        return false;
      }
    });
  }, []);
  // ---- setup mutations
  var _g = __read((0, client_1.useMutation)(sourceDefn.update.mutation, {
      onError: function (error) {
        throw new Error(error.message);
      }
    }), 2),
    updateSource = _g[0],
    _h = _g[1],
    updateSourceLoading = _h.loading,
    updateSourceData = _h.data;
  // --- load the initial record. While we could use the entity passed in, it's safer to re-load freshest data
  // note that the revrse fields are now always loaded in the details query
  var _j = (0, client_1.useQuery)(defn.details.query, {
      variables: {
        id: entity.slug
      },
      fetchPolicy: "no-cache"
    }),
    loading = _j.loading,
    entityData = _j.data;
  var _k = (0, client_1.useQuery)((0, entity_reverse_connect_query_1.entityReverseConnectQuery)(sourceDefn, "".concat(sourceField.name, " { ...EntityValueFields } ")), {
      fetchPolicy: "no-cache",
      variables: {
        orderBy: filterState.orderBy || 'name',
        filter: filterState.filter || {}
      }
    }),
    listLoading = _k.loading,
    listData = _k.data;
  var handleDoneClick = function () {
    // TODO work out the fields needed in this handler. 
    // It should report on the entities which were assigned to the current entity
    props.onComplete({});
  };
  var initialCheckedItems = (((_a = entityData === null || entityData === void 0 ? void 0 : entityData[defn.singleBySlugName]) === null || _a === void 0 ? void 0 : _a[fieldName]) || []).map(function (item) {
    return item.id;
  });
  var allItems = ((_b = listData === null || listData === void 0 ? void 0 : listData[sourceDefn.list.queryFieldName]) === null || _b === void 0 ? void 0 : _b.results) || [];
  // -- 1. Setup an effect to create an "initial" state once all data is loaded
  react_1.default.useEffect(function () {
    if (loading || listLoading) return;
    var valueState = {};
    allItems.forEach(function (item) {
      valueState[item.id] = {
        checked: initialCheckedItems.includes(item.id),
        loading: false,
        result: item
      };
    });
    setValueState(valueState);
  }, [loading, listData]);
  var handleCheckboxChange = function (item) {
    return function (checked) {
      return __awaiter(void 0, void 0, void 0, function () {
        var variables, mutationResult, updatedItem, updatedSourceValue, success;
        var _a, _b;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              // setup mutation on value state
              setValueState(function (prev) {
                var _a;
                return __assign(__assign({}, prev), (_a = {}, _a[item.id] = __assign(__assign({}, prev[item.id]), {
                  checked: checked,
                  loading: true
                }), _a));
              });
              variables = (0, lodash_1.pickBy)({
                id: item.id,
                remove: !checked && (_a = {}, _a[sourceField.name] = sourceFieldValue, _a),
                insert: checked && (_b = {}, _b[sourceField.name] = sourceFieldValue, _b)
              });
              return [4 /*yield*/, updateSource({
                variables: variables
              })];
            case 1:
              mutationResult = _c.sent();
              updatedItem = mutationResult.data[(0, entity_update_mutation_field_name_1.entityUpdateMutationFieldName)(sourceDefn)];
              updatedSourceValue = (0, utils_1.toArray)(updatedItem === null || updatedItem === void 0 ? void 0 : updatedItem[sourceField.name]).map(function (item) {
                return item.id;
              });
              success = checked ? updatedSourceValue.includes(entity.id) : !updatedSourceValue.includes(entity.id);
              if (success) {
                setValueState(function (prev) {
                  var _a;
                  return __assign(__assign({}, prev), (_a = {}, _a[item.id] = __assign(__assign({}, prev[item.id]), {
                    checked: checked,
                    assigned: true,
                    loading: false
                  }), _a));
                });
              } else {
                alert("Sorry, failed to update the ".concat(sourceDefn.label, " record."));
              }
              return [2 /*return*/];
          }
        });
      });
    };
  };
  var anyIsLoading = Object.values(valueState).some(function (item) {
    return item.loading;
  });
  var isLoading = loading || listLoading;
  var canClose = !loading && !anyIsLoading;
  var filteredItems = (0, lodash_1.filter)(allItems, function (item) {
    if (unassigned) {
      var itemState = valueState[item.id];
      return !itemState.checked || itemState.assigned || itemState.loading;
    }
    return true;
  });
  var _l = (0, use_infinite_scroll_array_1.useInfiniteScrollArray)({
      all: filteredItems,
      itemsPerPage: 20,
      rootMargin: '0px 0px 1000px 0px'
    }),
    sentryRef = _l.sentryRef,
    items = _l.items,
    hasNextPage = _l.hasNextPage;
  return react_1.default.createElement(My.Container, {
    className: cls.name(className)
  }, react_1.default.createElement(My.Head, null, react_1.default.createElement(My.ValueAndIntro, null, react_1.default.createElement(My.Value, {
    variant: 'small',
    entity: entity
  }), react_1.default.createElement(My.Intro, null, reverseFieldDefn.description && react_1.default.createElement(My.InfoTooltip, {
    message: t(reverseFieldDefn.description)
  }), react_1.default.createElement(My.IntroText, null, (0, sprintf_js_1.sprintf)(t('Select the %s connected to this %s:'), sourceDefn.pluralLabel, defn.label)))), react_1.default.createElement(My.Toggle, {
    onClick: function () {
      setUnassigned(!unassigned);
    },
    isOn: unassigned,
    label: "Show: ",
    offLabel: "All",
    onLabel: "Not Connected"
  })), isLoading && react_1.default.createElement(My.Loader, {
    spinnerSize: 24,
    message: 'Fetching existing connections. Please wait...'
  }), react_1.default.createElement(react_animate_height_1.default, {
    duration: 300,
    height: isLoading ? 0 : 'auto'
  }, react_1.default.createElement(My.Form, {
    className: cls.name('form'),
    name: formName
  }, react_1.default.createElement(My.Items, null, items.map(function (item) {
    var value = valueState[item.id];
    if (!value) {
      return null;
    }
    return react_1.default.createElement(My.Item, {
      key: item.id
    }, react_1.default.createElement(My.ValueCheckbox, {
      key: item.id,
      entity: item,
      title: item.name,
      name: (0, utils_1.truncateWords)(item.name, {
        max: 5
      }),
      checked: value.checked,
      loading: value.loading,
      onChange: handleCheckboxChange(item)
    }, react_1.default.createElement(My.Assignments, {
      fieldName: sourceField.name,
      entity: item
    })));
  }), hasNextPage && react_1.default.createElement("div", {
    ref: sentryRef
  }, react_1.default.createElement(My.Loader, {
    spinnerSize: 24,
    message: 'Please wait...'
  }))))));
};
exports.EntityReverseConnectForm = EntityReverseConnectForm;
exports.EntityReverseConnectForm.defaultProps = exports.EntityReverseConnectFormDefaultProps;
exports.EntityReverseConnectForm.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39;